export default {
  Base: '0px 2px 8px rgba(0,0,0,0.2)',
  Medium: '0px 4px 16px rgba(0,0,0,0.2)',
  Large: '0px 8px 24px rgba(0,0,0,0.2)'
};